module.exports = __webpack_public_path__ + "assets/img/2291591947409_.pic_hd.c875623d.jpg";